import { SEOHead } from '@/components/seo/SEOHead';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist or has been moved. Navigate back to the Rooflyzer homepage."
        robots="noindex, nofollow"
      />

      <section className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <div className="text-8xl font-mono font-extrabold text-white tracking-tight mb-6">
            404
          </div>
          <h1 className="text-3xl font-bold text-white mb-4">Page Not Found</h1>
          <p className="text-white/70 text-lg mb-8 leading-relaxed">
            The page you&apos;re looking for doesn&apos;t exist or has been moved. Let&apos;s get
            you back on track.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              asChild
              className="bg-white text-slate-950 hover:bg-slate-100 font-semibold shadow-sm"
            >
              <Link to="/">
                <Home className="mr-2 size-4" />
                Back to Home
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="border-slate-700 bg-slate-800/60 text-slate-200 hover:text-white hover:bg-slate-700/60"
            >
              <Link to="/contact">
                <ArrowLeft className="mr-2 size-4" />
                Contact Support
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};
